import routes from './routes/index';

//-- Get Routes
const getAllRoutes = (rts = routes, accumulator = []) => {
	for (const r of rts) {
		if (r.meta.enabled) {
			if (r.meta.children) {
				getAllRoutes(r.meta.children, accumulator);
			}

			accumulator.push(r);
		}
	}

	return accumulator;
};

const getLevel1ContentRoutes = () => {
	const level1ContentRoutes = routes.filter((m) => m.meta.level === 1 && m.meta.content && m.meta.enabled);
	return level1ContentRoutes;
};

const getLevel1SettingsRoutes = () => {
	const level1SettingsRoutes = routes.filter((m) => m.meta.level === 1 && m.meta.settings && m.meta.enabled);
	return level1SettingsRoutes;
};

export const getParentRoute = (id) => {
	const parentRoute = routes.find((r) => r.meta.children?.find((c) => c.id === id) && r.meta.enabled);
	return parentRoute;
};

const getSignInRoute = () => {
	const signInRoute = routes.find((r) => r.meta.signIn && r.meta.enabled);
	return signInRoute;
};

const getSignOutRoute = () => {
	const signOutRoute = routes.find((r) => r.meta.signOut && r.meta.enabled);
	return signOutRoute;
};

const getHomeRoute = () => {
	const homeRoute = routes.find((r) => r.meta.home && r.meta.enabled);
	return homeRoute;
};

const getSetupRequiredRoute = () => {
	const setupRequiredRoute = routes.find((r) => r.meta.setupRequired && r.meta.enabled);
	return setupRequiredRoute;
};

const getUnauthorizedRoute = () => {
	const unauthorizedRoute = routes.find((r) => r.meta.unauthorized && r.meta.enabled);
	return unauthorizedRoute;
};

const getLoginFailedRoute = () => {
	const loginFailedRoute = routes.find((r) => r.meta.loginFailed && r.meta.enabled);
	return loginFailedRoute;
};

const getHttpErrorRoute = () => {
	const httpErrorRoute = routes.find((r) => r.meta.httpError && r.meta.enabled);
	return httpErrorRoute;
};

const getPageNotFoundRoute = () => {
	const pageNotFoundRoute = routes.find((r) => r.meta.pageNotFound && r.meta.enabled);
	return pageNotFoundRoute;
};

export const allRoutes = getAllRoutes();
export const level1ContentRoutes = getLevel1ContentRoutes();
export const level1SettingsRoutes = getLevel1SettingsRoutes();
export const signInRoute = getSignInRoute();
export const signOutRoute = getSignOutRoute();
export const homeRoute = getHomeRoute();
export const loginFailedRoute = getLoginFailedRoute();
export const setupRequiredRoute = getSetupRequiredRoute();
export const unauthorizedRoute = getUnauthorizedRoute();
export const httpErrorRoute = getHttpErrorRoute();
export const pageNotFoundRoute = getPageNotFoundRoute();
